import { render } from "./TotalOrdersChart.vue?vue&type=template&id=4b342b0b&scoped=true&ts=true"
import script from "./TotalOrdersChart.vue?vue&type=script&lang=ts"
export * from "./TotalOrdersChart.vue?vue&type=script&lang=ts"

import "./TotalOrdersChart.vue?vue&type=style&index=0&id=4b342b0b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b342b0b"]])

export default __exports__